/* eslint-disable no-undef */
import React from 'react';
import { Flex, Text, Image, Box, Button } from 'rebass';
import closeIcon from 'assets/icons/close.png';
import styled from 'styled-components';
import colors from 'theme/colors';
import Form from 'components/Form';
import Field from 'components/Field';
import { StyledShareLinkInput } from 'components/Input';
import ErrorMessage from 'components/ErrorMessage';
import { startShareLinkByEmailSubmit, resolveShareLinkByEmailSubmit } from './actions';
import useShareLinkModal from './hooks/useShareLinkModal';
import ModalContent from '../ModalContent';

const NavButtonWrapper = styled(Flex)<any>`
  #navButtonHover {
    visibility: ${props => props.active && 'visible'};
  }
`;
const NavButtonActive = styled(Box)`
  background: ${colors.turquoise};
  height: 5px;
  border-radius: 5px;
  visibility: hidden;
`;

const FormButton = styled(Button)`
  width: 150px;
  font-size: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const Content = styled(ModalContent)`
  flex-direction: column;
  padding: 35px;
`;

interface ShareLinkModalProps {
  closeModalHandler: VoidFunction;
}

const ShareLinkModal: React.FC<ShareLinkModalProps> = ({ closeModalHandler }) => {
  const {
    inputEl,
    shareLinkType,
    setShareLinkTypeByLink,
    setShareLinkTypeByEmail,
    modal,
  } = useShareLinkModal();
  return (
    <Content>
      <Flex width="100%" justifyContent="flex-end" mb={1} onClick={closeModalHandler}>
        <Image src={closeIcon} css="cursor: pointer" />
      </Flex>
      <Text fontSize="24px" mb={2}>
        Create your candidate pool faster!
      </Text>
      <Text fontSize="15px" mb={4}>
        Share a link with a candidate and let them create their own profile.
      </Text>
      <Flex width="100%">
        <Flex as="nav" width="100%" justifyContent="space-between" css="max-width: 125px;" mb={1}>
          <NavButtonWrapper flexDirection="column" active={shareLinkType === 'byLink'}>
            <Button variant="navigation" onClick={setShareLinkTypeByLink} css="font-size: 17px;">
              Link
            </Button>
            <NavButtonActive id="navButtonHover" />
          </NavButtonWrapper>
          <NavButtonWrapper flexDirection="column" active={shareLinkType === 'byEmail'}>
            <Button variant="navigation" onClick={setShareLinkTypeByEmail} css="font-size: 17px;">
              Email
            </Button>
            <NavButtonActive id="navButtonHover" />
          </NavButtonWrapper>
        </Flex>
      </Flex>
      {shareLinkType === 'byLink' && (
        <Flex width="100%" flexDirection="column" alignItems="center">
          <StyledShareLinkInput ref={inputEl} width="100%" defaultValue={`${modal.data.url}`} />
          <Flex mt={5}>
            <FormButton variant="primary" mr={3} onClick={closeModalHandler}>
              Cancel
            </FormButton>
            <FormButton variant="primary" onClick={() => document.execCommand('copy')}>
              Copy
            </FormButton>
          </Flex>
        </Flex>
      )}
      {shareLinkType === 'byEmail' && (
        <Flex>
          <Form
            startSubmitAction={startShareLinkByEmailSubmit().type}
            resolveSubmitAction={resolveShareLinkByEmailSubmit().type}
            setPayload={(action: object, payload: any) => ({
              ...action,
              payload: {
                ...payload,
                link: modal.data.url,
              },
            })}
          >
            {(formProps: any) => {
              const { submitting, submitErrors } = formProps;
              return (
                <Flex flexDirection="column" alignItems="center">
                  {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
                  <Field
                    name="email"
                    inputType="shareLink"
                    placeholder="Invite by email address"
                    width="455px"
                  />
                  <Flex mt={5}>
                    <FormButton variant="primary" mr={3} onClick={closeModalHandler}>
                      Cancel
                    </FormButton>
                    <FormButton type="submit" variant={submitting ? 'disabled' : 'primary'}>
                      Send invite
                    </FormButton>
                  </Flex>
                </Flex>
              );
            }}
          </Form>
        </Flex>
      )}
    </Content>
  );
};

export default ShareLinkModal;
